import { LABEL_FA_SOLID_ICON_NAMES, LABEL_ICOMOON_ICON_NAMES, LABEL_ICON_NAMES } from './label.icons.generated';

export { LABEL_FA_SOLID_ICON_NAMES, LABEL_ICOMOON_ICON_NAMES, LABEL_ICON_NAMES };
export type { LabelFaSolidIconName, LabelIcomoonIconName, LabelIconName } from './label.icons.generated';

const ICOMOON_ICON_SET = new Set<string>(LABEL_ICOMOON_ICON_NAMES);
const FA_SOLID_ICON_SET = new Set<string>(LABEL_FA_SOLID_ICON_NAMES);
const LABEL_ICON_SET = new Set<string>(LABEL_ICON_NAMES);

const ICOMOON_CLASS_PREFIX = 'icomoon icomoon-';
const FA_SOLID_CLASS_PREFIX = 'fa-solid fa-';

/** Closed set for Zod/OpenAPI enums. */
export const LABEL_ICON_NAME_ENUM = LABEL_ICON_NAMES as unknown as readonly [string, ...string[]];

export function isIcomoonLabelIcon(name: string | undefined): boolean {

    return !!name && ICOMOON_ICON_SET.has(name);
}

export function isLabelIconName(name: string | undefined): boolean {

    return !!name && LABEL_ICON_SET.has(name);
}

/**
 * Public icon name → stored CSS class.
 * Icomoon names are detected by membership in LABEL_ICOMOON_ICON_NAMES, not by prefix guessing.
 */
export function toStoredLabelIconClass(name: string | undefined): string | undefined {

    if (!name) return undefined;
    if (ICOMOON_ICON_SET.has(name)) return `${ICOMOON_CLASS_PREFIX}${name}`;
    if (FA_SOLID_ICON_SET.has(name)) return `${FA_SOLID_CLASS_PREFIX}${name}`;
    return undefined;
}

/** Stored CSS class → public icon name. Unknown/legacy classes (pi, fa fa-) return undefined. */
export function fromStoredLabelIconClass(stored: string | undefined | null): string | undefined {

    if (!stored) return undefined;
    if (stored.startsWith(ICOMOON_CLASS_PREFIX)) {
        const name = stored.slice(ICOMOON_CLASS_PREFIX.length);
        return ICOMOON_ICON_SET.has(name) ? name : undefined;
    }
    if (stored.startsWith(FA_SOLID_CLASS_PREFIX)) {
        const name = stored.slice(FA_SOLID_CLASS_PREFIX.length);
        return FA_SOLID_ICON_SET.has(name) ? name : undefined;
    }
    return undefined;
}

/** FA solid `tag` — the label glyph. Used when public create omits icon. */
export const DEFAULT_LABEL_ICON = 'tag';

export function defaultLabelIcon(): string {

    return DEFAULT_LABEL_ICON;
}

export function resolveLabelIcon(icon?: string): string | undefined {

    if (!icon) return defaultLabelIcon();
    return isLabelIconName(icon) ? icon : undefined;
}
